import React from 'react';

/**
 * CORE-UAT-03 — reusable client-logo presentation.
 * Handles transparent/white backgrounds, square/horizontal proportions and
 * pre-framed logos: aspect ratio always preserved (object-contain), bounded by
 * max sizes, subtle neutral surface, generous padding, never cropped or forced
 * into a circular frame.
 */
export const ClientLogo = ({ src, alt = '', size = 'hero', className = '', ...rest }) => {
  if (!src) return null;
  const imgSizes = {
    hero: 'max-h-20 lg:max-h-24 max-w-[200px] lg:max-w-[240px]',
    compact: 'max-h-9 max-w-[130px]',
  };
  return (
    <div
      className={`inline-flex items-center justify-center rounded-xl bg-white/95 border border-white/20 shadow-elevated px-4 py-3 ${className}`}
      {...rest}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`${imgSizes[size] || imgSizes.hero} w-auto h-auto object-contain`}
      />
    </div>
  );
};
